import { Link } from "react-router-dom";
import s from "./platformAdmin.module.css";

function BackIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M15 6l-6 6 6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * Единый заголовок страниц админки: на телефоне компактный hub, на десктопе — hero.
 */
export default function PlatformPageHeader({
  title,
  lead,
  eyebrow,
  backTo,
  backLabel = "Назад",
  actions,
  compactOnMobile = true,
  mobileOnlyBack = false,
}) {
  return (
    <header
      className={`${s.pageHero} ${compactOnMobile ? s.pageHeroMobileCompact : ""}`.trim()}
    >
      {backTo ? (
        <Link
          to={backTo}
          className={
            mobileOnlyBack ? `${s.hubBack} ${s.hubBackMobileOnly}` : s.hubBack
          }
        >
          <BackIcon /> {backLabel}
        </Link>
      ) : null}
      <div className={s.pageHeroMain}>
        <div className={s.pageHeroText}>
          {eyebrow ? <div className={s.eyebrow}>{eyebrow}</div> : null}
          <h1 className={s.pageTitle}>{title}</h1>
          {lead ? <p className={s.pageLead}>{lead}</p> : null}
        </div>
        {actions ? <div className={s.heroActions}>{actions}</div> : null}
      </div>
    </header>
  );
}
